import type { MatterDTO } from "../api/types/matter";
import { VISAVALUE, type NonEmptyVisa } from "../types/visa.type";

export function asVisaValue(visa?: string | null): NonEmptyVisa {
  const raw = String(visa ?? "").trim();
  const values = Object.values(VISAVALUE) as string[];
  if (values.includes(raw)) return raw as NonEmptyVisa;
  return VISAVALUE.EMPTY as NonEmptyVisa;
}

function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== "object") return null;
  return value as Record<string, unknown>;
}

export function getPetitionerName(matter: MatterDTO): string {
  const individual = asRecord(matter.individual) ?? {};
  const employerInfo = asRecord(individual.employerInfo);
  const employerLegalBusinessName =
    typeof employerInfo?.legalBusinessName === "string"
      ? employerInfo.legalBusinessName
      : "";
  const { employerPetitioner, petitionerName: legacyPetitionerName } =
    individual as Record<string, unknown>;

  const petitionerName: string =
    (typeof employerLegalBusinessName === "string"
      ? employerLegalBusinessName
      : "") ||
    (typeof employerPetitioner === "string"
      ? employerPetitioner
      : employerPetitioner === true &&
        typeof employerLegalBusinessName === "string"
      ? employerLegalBusinessName
      : "") ||
    (typeof legacyPetitionerName === "string" ? legacyPetitionerName : "");

  const display = petitionerName.trim();
  return display.length ? display : "-";
}
